export const LogoMark = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="40" height="40" rx="10" fill="url(#pcs-logo-grad)" />
        <path d="M12 10H23C26.3137 10 29 12.6863 29 16C29 19.3137 26.3137 22 23 22H18V30H12V10Z" fill="white" />
        <path d="M18 15H23C23.5523 15 24 15.4477 24 16C24 16.5523 23.5523 17 23 17H18V15Z" fill="#0A1128" />
        <path d="M25 25L28 28L34 20" stroke="#38BDF8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
            <linearGradient id="pcs-logo-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1E40AF" />
                <stop offset="1" stopColor="#0284C7" />
            </linearGradient>
        </defs>
    </svg>
);

export const Logo = () => (
    <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
        <LogoMark />
        <div className="leading-tight">
            <div className="font-heading font-extrabold text-base sm:text-lg tracking-tight text-white">PRAMUKH</div>
            <div className="font-mono2 text-[8px] sm:text-[9px] tracking-[0.3em] text-sky-400 uppercase">Compliance Services</div>
        </div>
    </a>
);
